import createStorage from './storage';

export default createStorage(localStorage);
